function Search({ fill = "#2E5BFF" }) {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8519 12.1372L9.67928 8.96461C10.4679 8.01628 10.943 6.79853 10.943 5.47167C10.943 2.45458 8.48848 0 5.47153 0C2.45451 0 0 2.45458 0 5.47167C0 8.48856 2.45451 10.9429 5.47153 10.9429C6.79832 10.9429 8.01614 10.4679 8.96446 9.67929L12.1372 12.8519C12.2358 12.9506 12.3652 13 12.4945 13C12.6239 13 12.7532 12.9506 12.852 12.8519C13.0494 12.6545 13.0494 12.3346 12.8519 12.1372ZM1.01086 5.47167C1.01086 3.01197 3.0119 1.01086 5.47153 1.01086C7.93109 1.01086 9.93206 3.01197 9.93206 5.47167C9.93206 7.93117 7.93109 9.93207 5.47153 9.93207C3.0119 9.93207 1.01086 7.93117 1.01086 5.47167Z"
        fill={fill}
      />
    </svg>
  );
}

export default Search;
